import { PAYMENT_METHODS } from "../../apis/useSubmitPayment/types";
import alipayIcon from "../../assets/images/alipay.png";
import cashIcon from "../../assets/images/cash.png";
import mastercardIcon from "../../assets/images/mastercard.svg?url";
import netsIcon from "../../assets/images/nets.svg?url";
import netsFlashPayIcon from "../../assets/images/netsflashpay.png";
import netsQrIcon from "../../assets/images/netsqr.png";
import visaIcon from "../../assets/images/visa.svg?url";
import wechatIcon from "../../assets/images/wechatpay.png";

export interface IPaymentMethodConfig {
	label: string;
	icons?: string[];
	buttonLabel?: string;
}

export const PAYMENT_METHOD_CONFIG: Record<PAYMENT_METHODS, IPaymentMethodConfig> = {
	[PAYMENT_METHODS.FLASHPAY]: { label: "NETS FlashPay", icons: [netsFlashPayIcon] },
	[PAYMENT_METHODS.NETS]: { label: "NETS", icons: [netsIcon] },
	[PAYMENT_METHODS.NETSQR]: { label: "NETS QR", icons: [netsQrIcon] },
	[PAYMENT_METHODS.CREDITCARD]: {
		label: "Credit Card",
		icons: [visaIcon, mastercardIcon],
	},
	[PAYMENT_METHODS.ALIPAY_WECHAT]: {
		label: "Alipay+ / WeChat",
		icons: [alipayIcon, wechatIcon],
	},
	[PAYMENT_METHODS.CASH]: { label: "Cash", icons: [cashIcon], buttonLabel: "CASH" },
};

export const PAYMENT_PAGE_LAYOUT: Array<Array<PAYMENT_METHODS | null>> = [
	[
		PAYMENT_METHODS.FLASHPAY,
		PAYMENT_METHODS.NETS,
		PAYMENT_METHODS.NETSQR,
		PAYMENT_METHODS.CREDITCARD,
		PAYMENT_METHODS.ALIPAY_WECHAT,
		null,
	],
	[PAYMENT_METHODS.CASH, null, null, null, null, null],
];
